import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { ContactFilterConditionInterface } from '../../types/contact-filter-interface'
import { getFilterApi } from '../../utils/get-filter-api'
import { REMOVED_CONTACTS_API } from '../api/removed-contacts-api'
import { ContactRemovedApiInterface } from '../types/contact-removed-interface'

interface UseContactsRemovedInterface extends SwrPaginationInterface {
  conditions: ContactFilterConditionInterface[]
}
export function useContactsRemovedList({
  limit,
  pagination,
  conditions,
}: UseContactsRemovedInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactRemovedApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = getFilterApi(conditions)

  const { data: removedContacts, abort } = useControlledSwr(() => {
    if (user && pagination.startFromId === undefined && limit) {
      return `${REMOVED_CONTACTS_API}/list?pagination[limit]=${limit}${filterApi}`
    } else if (user && pagination.startFromId && limit) {
      return `${REMOVED_CONTACTS_API}/list?${getPaginationQueryString({
        limit,
        pagination,
      })}${filterApi}`
    }
    return null
  }, fetcher)

  return { removedContacts, abort }
}
